import React from 'react';

// The milestone ribbon's award mark (#4719; founder 2026-10-18: "the badge
// needs to be more appealing in a different color like a ribbon.. use
// industry best practice like the way it is done"). Mock round #4719,
// variant C: a garnet ribbon banner that runs off the bar's left edge like a
// sash, with a swallowtail end and a gold hairline. The other variants
// (rosette, seal with banner, laurel) live on the unmerged mocks/4719 branch.
//
// The number is HTML text, never part of the drawing, so any served figure
// fits and reads. Contrast (WCAG AA, pinned in LandingProofStrip.test.jsx):
// cream number on the ribbon's darkest and lightest garnet 8.42:1 and
// 7.35:1; the gold label 5.23:1 and 4.56:1. Past 1280px (max-w-7xl) the bar's
// content no longer starts at the window edge, so the left end is notched too.
export const AWARD = {
    ribbon: '#9B1D2E',
    ribbonDeep: '#7E1524',
    gold: '#F5B942',
    cream: '#FFF4D6',
};

export default function MilestoneBadge({ badge, label }) {
    return (
        <span data-testid="milestone-ribbon-badge"
            className="-ml-3 flex shrink-0 items-stretch self-stretch sm:-ml-6 lg:-ml-8">
            <svg width="12" viewBox="0 0 12 40" preserveAspectRatio="none" aria-hidden="true"
                className="-mr-px hidden h-auto min-[1281px]:block">
                <path d="M12 0 H0 L6 20 L0 40 H12 Z" fill={AWARD.ribbonDeep} />
            </svg>
            <span className="milestone-shine relative flex flex-col justify-center border-y border-[#F5B942]/70 bg-gradient-to-b from-[#9B1D2E] to-[#7E1524] py-0.5 pl-3 pr-2 leading-none shadow-[0_2px_4px_rgba(0,0,0,0.3)] sm:pl-6 lg:pl-8 min-[1281px]:pl-3">
                <span className="text-[9px] font-semibold uppercase tracking-[0.14em] text-[#F5B942] sm:text-[10px]">{label}</span>
                <span className="mt-1 font-serif text-[17px] font-bold text-[#FFF4D6] sm:text-xl">{badge}</span>
            </span>
            <svg width="14" viewBox="0 0 14 40" preserveAspectRatio="none" aria-hidden="true" className="-ml-px h-auto">
                <path d="M0 0 H14 L6 20 L14 40 H0 Z" fill={AWARD.ribbonDeep} />
                <path d="M0 0 H14 L6 20 L0 20 Z" fill={AWARD.ribbon} />
                <path d="M0 0.5 H13" stroke={AWARD.gold} strokeOpacity="0.7" strokeWidth="1" />
                <path d="M0 39.5 H13" stroke={AWARD.gold} strokeOpacity="0.7" strokeWidth="1" />
            </svg>
        </span>
    );
}
